import { render, staticRenderFns } from "./partnerPolicy.vue?vue&type=template&id=2b88d11c&scoped=true&"
import script from "./partnerPolicy.vue?vue&type=script&lang=js&"
export * from "./partnerPolicy.vue?vue&type=script&lang=js&"
import style0 from "./partnerPolicy.vue?vue&type=style&index=0&id=2b88d11c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88d11c",
  null
  
)

export default component.exports